import { render, staticRenderFns } from "./freezeGuidance.vue?vue&type=template&id=06474fa6&scoped=true&"
import script from "./freezeGuidance.vue?vue&type=script&lang=js&"
export * from "./freezeGuidance.vue?vue&type=script&lang=js&"
import style0 from "./freezeGuidance.vue?vue&type=style&index=0&id=06474fa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06474fa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06474fa6')) {
      api.createRecord('06474fa6', component.options)
    } else {
      api.reload('06474fa6', component.options)
    }
    module.hot.accept("./freezeGuidance.vue?vue&type=template&id=06474fa6&scoped=true&", function () {
      api.rerender('06474fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/freezeGuidance.vue"
export default component.exports